import { UiBox } from "@smp/ui";
import clsx from "clsx";

import { ITemplateMeta } from "@/components/features/polotno_templates/hooks";

import { useStyles } from "./template_preview.css";

export const TemplatePreview = ({
  src,
  meta,
}: {
  src?: string;
  meta?: ITemplateMeta;
}) => {
  const classes = useStyles();

  return (
    <UiBox
      className={clsx(classes.wrapper, { [classes.preview_fallback]: !src })}
    >
      {src && (
        <img
          src={src}
          alt={meta?.desc}
          title={meta?.name}
          className={classes.preview_image}
          width={meta?.size?.[0]}
          height={meta?.size?.[1]}
        />
      )}
    </UiBox>
  );
};
